<mat-card (click)="$event.stopPropagation()"
          (contextmenu)="showContextMenu($event)"
          (dblclick)="open()"
          (mousedown)="onMouseDown($event)"
          (mousemove)="onMouseMove()"
          (mouseup)="onMouseUp($event)"
          [class.docked-left]="image.posX === 0"
          [class.docked-top]="image.posY === 49"
          [matRippleDisabled]="rippleDisabled"
          class="flex-container" matRipple
          [cbHighlightColor]="undefined"
          [cbHighlightedItem]="image"
          style="padding: 5px 5px 0 5px; min-height: 32px"
          data-cy="image">
  <mat-card-title *ngIf="image.header" class="flex-container img-card-header">
    {{ image.header }}
  </mat-card-title>
  <ng-container *ngIf="image.source !== null; else local">
    <div *ngIf="!loadedFromUrlSuccess" class="image-link">
      {{ image.source }}
    </div>
    <img
      (load)="onImageLoadedFromUrl()"
      [class.hide]="!loadedFromUrlSuccess"
      [src]="image.source"
      alt="loading failed"
      class="animated"
      height="140"
      style="border-radius: 8px">
    <div class="img-button-group">
      <button (click)="showContextMenu($event)" (mousedown)="rippleDisabled=true"
              mat-icon-button [attr.aria-label]="'MORE' | translate">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </ng-container>
  <ng-template #local>
    <ng-container *ngIf="loadedFromStorage; else loading">
      <mat-icon class="file-icon" *ngIf="!loadedFromStorageSuccess">
        {{matIcon}}
      </mat-icon>
      <img
        [src]="loadedFromStorage"
        [class.hide]="!loadedFromStorageSuccess"
        (load)="onImageLoadedFromStorage()"
        class="animated"
        height="140"
        alt="loading failed"
        style="border-radius: 8px">
    </ng-container>
    <ng-template #loading>
      <div class="img-placeholder">
        <mat-icon>loop</mat-icon>
        <span>{{'LOAD_IMAGE' | translate}}</span>
      </div>
    </ng-template>
    <div class="img-button-group">
      <button (click)="showContextMenu($event)" (mousedown)="rippleDisabled=true"
              mat-icon-button [attr.aria-label]="'MORE' | translate">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </ng-template>
</mat-card>

<div [matMenuTriggerFor]="contextMenu"
     [style.left.px]="rightClickPosX"
     [style.top.px]="rightClickPosY"
     style="visibility: hidden; position: fixed">
</div>
<mat-menu #contextMenu="matMenu">
  <button *ngIf="!image.selected" (click)="select()" mat-menu-item
          [attr.aria-label]="'SELECT' | translate">
    <mat-icon>check</mat-icon>
    {{ 'SELECT' | translate }}
  </button>

  <button *ngIf="image.selected" (click)="select()" mat-menu-item
          [attr.aria-label]="'REMOVE_SELECTION' | translate">
    <mat-icon>close</mat-icon>
    {{ 'REMOVE_SELECTION' | translate }}
  </button>

  <ng-container *ngIf="!dataService.selectedItemsCount">
    <button (click)="edit()" mat-menu-item
            [attr.aria-label]="'EDIT' | translate">
      <mat-icon>edit</mat-icon>
      {{ 'EDIT' | translate }}
    </button>

    <button (click)="delete()" mat-menu-item
            [attr.aria-label]="'DELETE' | translate">
      <mat-icon>delete</mat-icon>
      {{ 'DELETE' | translate }}
    </button>
  </ng-container>

  <ng-container *ngIf="!dataService.selectedItemsCount">
    <button [matMenuTriggerFor]="movement" mat-menu-item
            [attr.aria-label]="'MOVE' | translate">
      <mat-icon>auto_awesome_motion</mat-icon>
      {{ 'MOVE' | translate }}
    </button>

    <ng-container *ngIf="dataService.tabs.length > 1">
      <button [matMenuTriggerFor]="tabs" mat-menu-item
              [attr.aria-label]="'SEND_TO_TAB' | translate">
        <mat-icon>tab</mat-icon>
        {{ 'SEND_TO_TAB' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="dataService.itemsCount > 1">
      <button [matMenuTriggerFor]="connectableItems" mat-menu-item
              [attr.aria-label]="'CONNECT_TO' | translate">
        <mat-icon>cable</mat-icon>
        {{ 'CONNECT_TO' | translate }}
      </button>
    </ng-container>

    <button (click)="open()" mat-menu-item
            [attr.aria-label]="'OPEN_LINK' | translate">
      <mat-icon>open_in_new</mat-icon>
      {{ 'OPEN_LINK' | translate }}
    </button>

    <button (click)="copy()" mat-menu-item
            [attr.aria-label]="'COPY_LINK' | translate">
      <mat-icon>content_copy</mat-icon>
      {{ 'COPY_LINK' | translate }}
    </button>
  </ng-container>
</mat-menu>

<mat-menu #movement="matMenu">
  <button (click)="dataService.bringToFront(image)" mat-menu-item
          [attr.aria-label]="'BRING_TO_FRONT' | translate">
    <mat-icon>flip_to_front</mat-icon>
    {{ 'BRING_TO_FRONT' | translate }}
  </button>
  <button (click)="dataService.bringForward(image)" mat-menu-item
          [attr.aria-label]="'BRING_FORWARD' | translate">
    <mat-icon>add_circle_outline</mat-icon>
    {{ 'BRING_FORWARD' | translate }}
  </button>
  <button (click)="dataService.sendBackward(image)" mat-menu-item
          [attr.aria-label]="'SEND_BACKWARD' | translate">
    <mat-icon>remove_circle_outline</mat-icon>
    {{ 'SEND_BACKWARD' | translate }}
  </button>
  <button (click)="dataService.flipToBack(image)" mat-menu-item
          [attr.aria-label]="'SEND_TO_BACK' | translate">
    <mat-icon>flip_to_back</mat-icon>
    {{ 'SEND_TO_BACK' | translate }}
  </button>
</mat-menu>

<mat-menu #tabs="matMenu">
  <ng-container *ngFor="let tab of dataService.tabs">
    <button (click)="moveToTab(tab.index)" *ngIf="dataService.selectedTabIndex !== tab.index" mat-menu-item
            [attr.aria-label]="'SEND_TO_TAB' | translate">
      <mat-icon>arrow_forward</mat-icon>
      {{tab.label ? tab.label : '#Board ' + (tab.index + 1)}}
    </button>
  </ng-container>
</mat-menu>

<mat-menu #connectableItems="matMenu">
  <ng-container *ngFor="let item of dataService.tab.notes">
    <button (click)="connectTo(item)" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{image.connectedTo?.includes(item.id) ? 'close' : 'note'}}</mat-icon>
      {{DisplayValue.fromNote(item)}}
    </button>
  </ng-container>
  <ng-container *ngFor="let item of dataService.tab.noteLists">
    <button (click)="connectTo(item)" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{image.connectedTo?.includes(item.id) ? 'close' : 'sticky_note_2'}}</mat-icon>
      {{DisplayValue.fromNoteList(item)}}
    </button>
  </ng-container>
  <ng-container *ngFor="let item of dataService.tab.taskLists">
    <button (click)="connectTo(item)" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{image.connectedTo?.includes(item.id) ? 'close' : 'list'}}</mat-icon>
      {{DisplayValue.fromTaskList(item)}}
    </button>
  </ng-container>
  <ng-container *ngFor="let item of dataService.tab.images">
    <button (click)="connectTo(item)" *ngIf="image !== item"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate"
            [style.background]="'var(--color-note)'">
      <mat-icon>{{image.connectedTo?.includes(item.id) ? 'close' : 'link'}}</mat-icon>
      {{DisplayValue.fromImage(item)}}
    </button>
  </ng-container>
  <button *ngIf="image.connectedTo"  (click)="connectTo(undefined)"
          mat-menu-item [attr.aria-label]="'CONNECT_TO_NOTHING' | translate"
          [style.background]="'var(--color-note)'">
    <mat-icon>link_off</mat-icon>
    {{'CONNECT_TO_NOTHING' | translate}}
  </button>
</mat-menu>
